<template>
    <div class="Menulist" style="padding: 10px 0">
        <div style="padding: 10px 0;">
            <el-button style="color: #000" @click="handleAdd">新增</el-button>
        </div>
        <el-table
                :data="menulist"
                :header-cell-style="{'text-align':'center',background:'#eef1f6',color:'#000'}"
                style="width: 100%"
                row-key="i_id"
                border
                lazy
                ref="multipleTable"
                :load="load"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                v-loading="loading">
            <el-table-column
                    label="序号"
                    align="center"
                    width="100">
                <template slot-scope="scope">
                    {{scope.$index+1}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="i_id"
                    label="菜单ID"
                    align="center"
                    width="100">
            </el-table-column>
            <el-table-column

                    prop="vc_name"
                    align="center"
                    label="菜单名称">
            </el-table-column>
            <el-table-column

                    label="菜单url"
                    align="center"
                    prop="vc_url">
            </el-table-column>
            <el-table-column
                    width="120"
                    label="顺序号"
                    align="center"
                    prop="i_order">
            </el-table-column>
            <el-table-column
                    label="是否有效" align="center" width="120">
                <template slot-scope="scope">
                    <div v-if="scope.row.i_state"><i class="el-icon-check"></i></div>
                    <div v-if="!scope.row.i_state"><i class="el-icon-close"></i></div>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <div class="done">
                        <div @click="handleEdit(scope.row)">编辑 <span>|</span></div>
                        <div @click="handleDelete( scope.row)">删除</div>
                        <div @click="handleAddson(scope.row)" 　v-if="scope.row.i_level!==3">
                            <span>|</span>新增子菜单
                        </div>
                        <div @click="port( scope.row)"><span>|</span>接口配置</div>
                    </div>
                </template>
            </el-table-column>

        </el-table>
        <!-- 编辑时候的弹出层 -->
        <el-dialog title="编辑菜单" :visible.sync="dialogFormVisible" width="30%" height="300px"
                   :close-on-click-modal="false"  @close="dialogCloseedit">
            <el-form :model="form" ref="formedit" :rules="refEdit" label-width="100px" class="demo-ruleForm"
                     v-loading="detail_loading">
                <el-form-item label="菜单URL" prop="vc_url">
                    <el-input v-model="form.vc_url" style="width: 90%"></el-input>
                </el-form-item>
                <el-form-item label="显示次序" prop="i_order">
                    <el-col :span="8">
                        <el-input v-model.number="form.i_order"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-checkbox v-model="statechecked">是否有效</el-checkbox>
                    </el-col>
                    <!--                    <el-col :span="8">-->
                    <!--                        <el-checkbox v-model="initchecked">是否初始化菜单</el-checkbox>-->
                    <!--                    </el-col>-->
                </el-form-item>

                <el-form-item label="菜单类型" prop="vc_types">
                    <el-select v-model="form.vc_types" multiple placeholder="请选择菜单类型">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template>
                    <el-table
                            :data="form.edittable"
                            height="250"
                            border>
                        <el-table-column label="字符集" width="160">
                            <template scope="scope">
                                <el-input size="small" v-model="scope.row.vc_lang"
                                          @change="handlelang(scope.row.vc_lang)" class="tableForm-item" disabled></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="菜单名称" prop="vc_name">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'edittable.'+scope.$index+'.vc_name'"
                                              :rules="refEdit.vc_name">
                                    <el-input v-model="scope.row.vc_name"
                                              @change="handlelang( scope.row.vc_name)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

            </el-form>

            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('formedit')" :disabled="iseditbtn">保存</el-button>
            </div>
        </el-dialog>
        <!-- 新增时候的弹出层 -->
        <el-dialog :title="isaddchilren?'新增子菜单':'新增菜单'" :visible.sync="dialogFormVisibleadd" @close="dialogClose"
                   width="30%" :close-on-click-modal="false">
            <el-form :model="formparent" ref="formadd" :rules="rulesadd" label-width="100px" class="demo-ruleForm">
                <el-form-item label="菜单URL" prop="vc_url">
                    <el-input v-model="formparent.vc_url" style="width: 90%"></el-input>
                </el-form-item>
                <div style="display: flex;align-items: center;margin-bottom: 20px;">
                    <el-form-item label="显示次序" prop="i_order" style="margin-bottom: 0px;">
                        <el-input v-model.number="formparent.i_order" style="width: 90%"></el-input>
                    </el-form-item>
                    <el-checkbox v-model="formparent.i_state">是否有效</el-checkbox>
                    <!--                    <el-checkbox v-model="formparent.i_init">是否初始化菜单</el-checkbox>-->
                </div>
                <el-form-item label="菜单类型" prop="vc_types">
                    <el-select v-model="formparent.vc_types" multiple placeholder="请选择菜单类型">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template>
                    <el-table
                            :data="formparent.tableData"
                            height="250"
                            border>
                        <el-table-column label="字符集" width="160">
                            <template scope="scope">
                                <el-input size="small" v-model="scope.row.vc_lang"
                                          @change="handlelang(scope.row.vc_lang)"
                                          class="tableForm-item" 　disabled></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="菜单名称" prop="vc_name">
                            <template slot-scope="scope">
                                <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.vc_name'"
                                              :rules="rulesadd.vc_name">
                                    <el-input v-model="scope.row.vc_name"
                                              @change="handlelang( scope.row.vc_name)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisibleadd = false">取 消</el-button>
                <el-button type="primary" @click="saveadd('formadd')" v-if="isshow" :disabled="isaddbtn">保存</el-button>
                <el-button type="primary" @click="saveaddson('formadd')" v-if="isshowson" :disabled="isaddsonbtn">保存
                </el-button>
            </div>
        </el-dialog>
        <!-- 接口配置弹出层 -->
        <el-dialog title="接口配置" :visible.sync="dialogFormVisibleport" width="50%" height="300px"
                   :close-on-click-modal="false" @close="dialogCloseport">
            <el-form :model="formport" ref="formport" label-width="100px" class="demo-ruleForm">
                <div v-for="(item,index) in formport.listport" :key="index">
                    <el-form-item label="接口地址" :prop="'listport.'+ index +'.vc_url'"
                                  :rules="[{required: true, message: '接口地址不能为空', trigger: 'blur'}]">
                        <el-input v-model="item.vc_url" style="width: 50%"></el-input>
                        <el-checkbox v-model="item.i_state">是否有效</el-checkbox>
                        <span @click="Deleteport(item,index)" style="cursor: pointer;color: #dbbc6f"
                              v-show="!item.isdelet">删除</span>
                    </el-form-item>
                </div>
                <i class="el-icon-circle-plus-outline"
                   style="font-size: 24px;text-align: center;margin-left: 50%;cursor: pointer"
                   @click="additem"> </i>
            </el-form>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button @click="dialogFormVisibleport = false">取 消</el-button>
                <el-button type="primary" @click="saveport('formport')" :disabled="issave">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";

    export default {
        name: "Menulist",
        data() {
            return {
                maps: new Map(),
                loading: false,
                issave: false,
                isadd: false,
                isdelet: true,
                addport_id: '',
                isaddbtn: false,
                isaddsonbtn: false,
                iseditbtn: false,
                isaddchilren: false,
                isyouxiao: false,
                dialogFormVisibleadd: false,
                dialogFormVisible: false,
                dialogFormVisibleport: false,
                checked: false,
                isshow: true,
                isshowson: false,
                detail_loading: false,
                i_pid: '',
                e_id: '',
                p_id: '',
                add_pid: '',
                p_level: '',
                isp_id: "",
                is_level: "",
                is_tree: '',
                mid: '',
                children_id: '',
                children_level: '',
                isstate: "",
                isinit: "",
                editstate: "",
                editinit: "",
                statechecked: '',
                statecheckedport: '',
                formport: {
                    listport: [{
                        vc_url: "",
                        i_state: true
                    }
                    ],
                },
                oldformport: [],
                options: [{
                    value: '1',
                    label: 'admin'
                }, {
                    value: '2',
                    label: '平台级'
                }, {
                    value: '3',
                    label: '企业级'
                }, {
                    value: '4',
                    label: '普通级'
                },],
                types: [],
                formparent: {
                    vc_url: '',
                    i_order: '',
                    //i_init: [],
                    i_state: [],
                    vc_types: [],
                    tableData: [{
                        vc_lang: 'zh_cn',
                        vc_name: '',
                    }, {
                        vc_lang: 'en_us',
                        vc_name: '',
                    },
                        {
                            vc_lang: 'ru_ru',
                            vc_name: '',
                        },
                    ],
                },
                form: {
                    vc_url: '',
                    i_order: '',
                    //i_init: [],
                    i_state: [],
                    vc_types: [],
                    edittable: [{
                        vc_lang: 'zh_cn',
                        vc_name: '',
                    }, {
                        vc_lang: 'en_us',
                        vc_name: '',
                    },
                        {
                            vc_lang: 'ru_ru',
                            vc_name: '',
                        },
                    ],
                },
                formadd: {},
                menulist: [],
                childrenlist: [],
                rulesadd: {
                    vc_url: [
                        {required: true, message: '请输入菜单URL', trigger: 'blur'},
                    ],
                    i_order: [
                        {required: true, message: '请输入显示次序', trigger: 'blur'},
                        {type: 'number', message: '显示次序必须为数字值',}
                    ],
                    vc_types: [
                        {required: true, message: '请选择菜单类型', trigger: 'change'}
                    ],
                    vc_name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'}
                    ],
                },
                refEdit: {
                    vc_url: [
                        {required: true, message: '请输入菜单URL', trigger: 'blur'},
                    ],
                    i_order: [
                        {required: true, message: '请输入显示次序', trigger: 'blur'},
                        {type: 'number', message: '次序必须为数字值',}
                    ],
                    vc_types: [
                        {required: true, message: '请选择菜单类型', trigger: 'change'}
                    ],
                    vc_name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'}
                    ],
                },
            }
        },
        mounted() {
            this.getlist()

        },
        created() {
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            //获取table
            async getlist() {
                this.loading = true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    i_pid: 0,
                    pageStart: 0,
                    pageSize: 10,
                    vc_language: "zh_cn",
                };
                let res = await API.menuelist(param);
                if (res.code == 1) {
                    this.loading = false;
                    this.menulist = res.menuList;

                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }

            },
            //新增接口配置
            async port(row) {
                this.addport_id = row.i_id;
                this.dialogFormVisibleport = true;
                let params = {
                    i_id: row.i_id,
                };
                let res = await API.getMenuInterfaceInfo(params);
                if (res.code == 1) {
                    if (res.interfaceList.length == 0) {
                        this.issave = true;
                        this.formport.listport = res.interfaceList;
                    } else {
                        this.issave = false;
                        this.formport.listport = res.interfaceList;
                        //对象拷贝
                        this.oldformport = [];
                        var newportlist = [];
                        for (var i = 0; i < res.interfaceList.length; i++) {
                            newportlist = Object.assign({}, res.interfaceList[i])
                            this.oldformport.push(newportlist);
                        }
                        for (var i = 0; i < this.formport.listport.length; i++) {
                            this.formport.listport[i].isdelet = true;
                            if (this.formport.listport[i].i_state == 1) {
                                this.formport.listport[i].i_state = true;
                            } else {
                                this.formport.listport[i].i_state = false;
                            }
                        }
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }
            },
            //新增一行
            additem() {
                this.issave = false;
                this.formport.listport.push({
                    vc_url: "",
                    i_state: true,
                    isdelet: false,
                    i_id: '',
                })
            },
            //删除一行
            Deleteport(item, index) {
                this.formport.listport.splice(index, 1);
                if (this.formport.listport.length == 0) {
                    this.issave = true;
                }
            },
            //保存
            async saveport(formRef) {
                this.$refs[formRef].validate(async valid => {
                    if (valid) {
                        for (var i = 0; i < this.formport.listport.length; i++) {
                            if (this.formport.listport[i].i_state == true) {
                                this.formport.listport[i].i_state = 1
                            } else {
                                this.formport.listport[i].i_state = 0
                            }
                        }
                        var nochanged = [];
                        var upchanged = [];
                        this.formport.listport.forEach(item => {
                            if (item.i_id == "") {
                                upchanged.push(item)
                            } else {
                                this.oldformport.forEach(item2 => {
                                    if (item.i_id == item2.i_id) {
                                        if (item.vc_url !== item2.vc_url || item.i_state !== item2.i_state) {
                                            upchanged.push(item)
                                        } else {
                                            nochanged.push(item)
                                        }
                                    }
                                })
                            }
                        })
                        let params = {
                            i_id: this.addport_id,
                            interfaceList: upchanged,
                            list: nochanged,
                        };
                        let res = await API.saveMenuInterface(params);
                        if (res.code == 1) {
                            this.$message.success(res.message);
                            this.getlist();
                            this.formport.listport=[];
                        } else if (res.code == -2) {
                            this.$router.push('/login')
                            this.$message.error(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                        this.dialogFormVisibleport = false;
                    } else {
                        return false;
                    }
                });
            },
            dialogClose() {
                //移除校验结果并重置字段值
                this.$refs.formadd.resetFields();
                this.formparent.i_state = false;
                //this.formparent.i_init = false;
            },
            dialogCloseedit() {
                //移除校验结果并重置字段值
                this.$refs.formedit.resetFields();
            },

            dialogCloseport() {
                this.formport.listport = {
                    vc_url: "",
                    i_state: ""
                }
            },
            //新增菜单
            handleAdd() {
                this.dialogFormVisibleadd = true;//开启弹出层
                this.isaddbtn = false;
                this.isaddchilren = false
                this.isshowson = false
                this.isshow = true
            },
            //新增子菜单
            handleAddson(row) {
                this.dialogFormVisibleadd = true;
                this.isaddsonbtn = false;
                this.isaddchilren = true;
                if (row) {
                    this.children_id = row.i_id
                    this.isshow = false
                    this.isshowson = true
                    if (row.i_pid !== 0) {
                        this.children_level = 3
                        this.isp_id = row.i_pid
                    } else {
                        this.children_level = 2
                        this.isp_id = row.i_id
                    }
                    this.add_pid = row.i_pid
                    this.is_level = row.i_level
                }
            },
            //添加子级菜单保存
            async saveaddson(ref) {
                let valid = await this.$formRulesValidate({ref, example: this});
                if (!valid) {
                    return
                }
                this.isaddsonbtn = true;
                if (this.formparent.i_state.length !== 0) {
                    this.isstate = 1
                } else {
                    this.isstate = 0
                }
                // if (this.formparent.i_init.length !== 0) {
                //     this.isinit = 1
                // } else {
                //     this.isinit = 0
                // }
                var Arr = this.formparent.vc_types;
                var min;
                for (var i = 0; i < Arr.length; i++) {
                    for (var j = i; j < Arr.length; j++) {
                        if (Arr[i] > Arr[j]) {
                            min = Arr[j];
                            Arr[j] = Arr[i];
                            Arr[i] = min;
                        }
                    }
                }
                var typesarr = Arr.join();
                let params = {
                    vc_url: this.formparent.vc_url,
                    i_order: this.formparent.i_order,
                    i_level: this.children_level,
                    i_pid: this.children_id,
                    // i_init: this.isinit,
                    i_state: this.isstate,
                    vc_types: typesarr,
                    vc_language: "zh_cn",
                    langList: this.formparent.tableData
                };
                let res = await API.savemenue(params);
                if (res.code == 1) {
                    this.isaddsonbtn = false;
                    if (this.is_tree == "") {
                        this.$message.success(res.message);
                        this.getlist();
                    } else if (this.is_tree !== "" && this.is_level == 1) {
                        this.$message.success(res.message);
                        this.getlist();
                        this.refreshLoadTree(this.isp_id);
                    } else {
                        this.$message.success(res.message);
                        this.getlist();
                        this.refreshLoadTree(this.isp_id);
                    }
                } else if (res.code == -2) {
                    this.isaddsonbtn = false;
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.isaddsonbtn = false;
                    this.$message.error(res.message);
                }
                this.dialogFormVisibleadd = false;
            },

            //新增保存
            async saveadd(ref) {
                // 校验数据
                let valid = await this.$formRulesValidate({ref, example: this});
                if (!valid) {
                    return;
                }
                this.isaddbtn = true;
                if (this.formparent.i_state == true) {
                    this.isstate = 1
                } else {
                    this.isstate = 0
                }
                // if (this.formparent.i_init== true) {
                //     this.isinit = 1
                // } else {
                //     this.isinit = 0
                // }
                var Arr = this.formparent.vc_types;
                var min;
                for (var i = 0; i < Arr.length; i++) {
                    for (var j = i; j < Arr.length; j++) {
                        if (Arr[i] > Arr[j]) {
                            min = Arr[j];
                            Arr[j] = Arr[i];
                            Arr[i] = min;
                        }
                    }
                }
                var typesarr = Arr.join();
                let params = {
                    vc_url: this.formparent.vc_url,
                    i_order: this.formparent.i_order,
                    i_level: 1,
                    i_pid: 0,
                    //i_init: this.isinit,
                    i_state: this.isstate,
                    vc_types: typesarr,
                    vc_language: "zh_cn",
                    langList: this.formparent.tableData

                };
                let res = await API.savemenue(params);
                if (res.code == 1) {
                    this.isaddbtn = false;
                    this.$message.success(res.message);
                    this.getlist();
                } else if (res.code == -2) {
                    this.isaddbtn = false;
                    this.$router.push('/login')
                    this.$message.error(res.message);
                } else {
                    this.isaddbtn = false;
                    this.$message.error(res.message);
                }

                this.dialogFormVisibleadd = false;


            },
            //编辑
            async handleEdit(row) {
                this.detail_loading = true;
                this.iseditbtn = false;
                this.dialogFormVisible = true
                this.e_id = row.i_id
                this.p_id = row.i_pid
                let params = {
                    i_id: row.i_id,
                };
                let res = await API.MenuInfo(params);
                if (res.code == 1) {
                    this.detail_loading = false;
                    this.form.vc_url = res.menuInfo.vc_url
                    this.form.i_order = res.menuInfo.i_order
                    this.form.edittable = res.menuInfo.langList
                    this.form.vc_types = res.menuInfo.vc_types.split(",")
                    this.i_pid = res.menuInfo.i_pid
                    if (res.menuInfo.i_state == 1) {
                        this.statechecked = true;
                    } else {
                        this.statechecked = false;
                    }
                    // if (res.menuInfo.i_init == 1) {
                    //     this.initchecked = true;
                    // } else {
                    //     this.initchecked = false;
                    // }
                    this.editoptions = res.menuInfo.vc_language
                    this.p_level = row.i_level
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }
                //对弹出层中的表单赋值
            },
            //编辑保存
            async saveEdit(ref) {
                let valid = await this.$formRulesValidate({ref, example: this});
                if (!valid) {
                    return
                } else {
                    this.iseditbtn = true;
                    if (this.statechecked == true) {
                        this.editstate = 1
                    } else {
                        this.editstate = 0
                    }
                    // if (this.initchecked == true) {
                    //     this.editinit = 1
                    // } else {
                    //     this.editinit = 0
                    // }

                    var Arr = this.form.vc_types;
                    var min;
                    for (var i = 0; i < Arr.length; i++) {
                        for (var j = i; j < Arr.length; j++) {
                            if (Arr[i] > Arr[j]) {
                                min = Arr[j];
                                Arr[j] = Arr[i];
                                Arr[i] = min;
                            }
                        }
                    }
                    var edittypesarr = Arr.join();
                    let params = {
                        i_id: this.e_id,
                        vc_url: this.form.vc_url,
                        i_order: this.form.i_order,
                        i_level: this.form.i_level,
                        i_pid: this.i_pid,
                        //i_init: this.editinit,
                        i_state: this.editstate,
                        vc_types: edittypesarr,
                        vc_language: "zh_cn",
                        langList: this.form.edittable
                    };
                    let res = await API.update(params);
                    if (res.code == 1) {
                        this.iseditbtn = false;
                        if (this.p_level == 1) {
                            this.$message.success(res.message);
                            this.getlist();
                        } else {
                            this.$message.success(res.message);
                            this.getlist();
                            this.refreshLoadTree(this.p_id)
                        }
                    } else if (res.code == -2) {
                        this.iseditbtn = false;
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    } else {
                        this.iseditbtn = false;
                        this.$message.error(res.message);
                    }
                }
                this.dialogFormVisible = false;
            },
            //获取子表格
            async getmenuelistson(pid) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                let param = {
                    i_mid: result.i_id,
                    i_pid: pid,
                    pageStart: 0,
                    pageSize: 10,
                    vc_language: "zh_cn",
                };
                let res = await API.menuelist(param);
                if (res.code == 1) {
                    this.childrenlist = res.menuList;
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }

            },

            load(tree, treeNode, resolve) {
                this.is_tree = tree.i_id
                this.maps.set(tree.i_id, {tree, treeNode, resolve});
                this.getmenuelistson(tree.i_id)
                setTimeout(() => {
                    resolve(
                        this.childrenlist
                    )
                }, 1000)
            },
            // 手动刷新函数
            refreshLoadTree(parentId) {
                // 根据父级id取出对应节点数据   pid一定
                let {tree, treeNode, resolve} = this.maps.get(parentId);
                this.$set(
                    this.$refs.multipleTable.store.states.lazyTreeNodeMap,
                    parentId,
                    []
                );
                if (tree) {
                    this.load(tree, treeNode, resolve);
                }
            },
            //input对应到表格
            handlelang(row) {
                this.formparent.tableData.vc_name = row;
            },
            // 删除
            handleDelete(row) {
                this.$confirm(
                    "删除此条数据，将会删除、修改，与此数据关联的所有数据！请谨慎操作！！！",
                    "提示！",
                    {
                        confirmButtonText: "确定删除",
                        cancelButtonText: "取消删除",
                        type: "warning",
                    }
                )
                    .then(async () => {
                        let params = {
                            i_id: row.i_id,
                        }
                        let res = await API.del(params);
                        if (res.code == 1) {
                            if (row.i_level == 1) {
                                this.$message.success("删除成功");
                                this.getlist();
                            } else {
                                this.$message.success("删除成功");
                                this.getlist();
                                this.refreshLoadTree(row.i_pid)
                            }
                        } else if (res.code == -2) {
                            this.$router.push('/login')
                            this.$message.error(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(() => {
                });
            },

        }
    }

</script>
<style lang="scss" scoped>
    .Menulist {
        .demo-table-expand {
            font-size: 0;
        }

        .demo-table-expand label {
            width: 90px;
            color: #99a9bf;
        }

        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 50%;
        }


        .dialog__title {
            font-size: 15px !important;
        }

        .el-checkbox {
            margin: 0 10px;
        }

        .el-dialog {
            top: 50%;
            transform: translate(0, -50%);
            margin-top: 0px !important;
        }
        /deep/.el-table .cell{
            overflow:inherit!important;
        }
    }

</style>
